export const defaultOptions = {
    times: 20,
    interval: 200,
};
export const TIMED_OUT_ERROR = 'waitUntil timed out';
//# sourceMappingURL=constants.js.map